'use client'

import { useEffect, useState } from 'react'

import { onAuthStateChanged, signInWithToken } from '@/shared/lib/firebase'
import type { FirebaseUser } from '@/shared/lib/firebase'

const getFirebaseCurrentUser = (): Promise<FirebaseUser | null> =>
  new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    })
  })

export const useFirebaseSignIn = ({
  firebaseToken,
  active,
}: {
  firebaseToken: string
  active: boolean
}) => {
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>(
    active ? 'loading' : 'ready',
  )
  const [userId, setUserId] = useState<number | null>(null)

  useEffect(() => {
    if (!active) return

    const tryAuth = async () => {
      const currentUser = await getFirebaseCurrentUser()

      if (currentUser) {
        setUserId(Number(currentUser.uid))
        setStatus('ready')

        return
      }

      try {
        const credential = await signInWithToken(firebaseToken)
        setUserId(Number(credential.user.uid))
        setStatus('ready')
      } catch {
        setStatus('error')
      }
    }

    void tryAuth()
  }, [firebaseToken, active])

  return { status, userId }
}
